import api from "@/lib/api";
import { isNative } from "@/lib/appConfig";
import { loginLanding } from "@/lib/engine";

// Destino tras entrar (login, alta, /app): un miembro del Engine aterriza en el Engine
// (decision D-B2). Aparte de lib/engine.js porque llama a la API y aquel es puro.
// Sin respuesta en 4 s se va al destino de siempre: el Engine nunca bloquea la entrada.
export async function engineLanding(target) {
    if (target !== "/app/dashboard" || isNative()) return target;
    const member = await api.get("/api/engine/me", { timeout: 4000 }).then(() => true, () => false);
    return loginLanding(target, { member, native: false });
}
